import React, { useState, useEffect } from "react";

// icons
import { IoClose } from "react-icons/io5";

export default function Rectangle(props) {
    // props
    const {
        data,

        availableCombinations,

        allowedVariantsValues,
        setAllowedVariantsValues,

        generateValues,

        selectedValue,
        setSelectedValue,
        dataLevel,

        setProductQuantity
    } = props

    // states
    // const [currentDataId, setCurrentDataId] = useState("");
    // const [allAvailableOptions, setAllAvailableOptions] = useState([]);

    // function to generate class name as per requirements
    const generatingClass = data => {
        if (data) {
            const value = data.replaceAll(" ", "").toLowerCase() // removing spaces and lowercasing
            return value
        }
        return ""
    }

    // setting default value
    useEffect(() => {
        if (data?.options?.length) {
            data.options.forEach(element => {
                if (element.is_default) {
                    const data = {
                        [element.option_variation_name.toLowerCase()]: {
                            value: element.value,
                        }
                    }

                    // setting current selected value
                    setSelectedValue({ ...selectedValue, ...data });
                }
            });
        }
    }, [data]);

    // function to get selected ids
    function removeSimilars(input) {
        let values = {};
        for (let value of input)
            if (!values[value.split('-')[0]]) {
                values[value.split('-')[0]] = value;
            }
        return Object.values(values);
    }

    // on value change
    const handleValueChange = (ev, item, dataLevel) => {
        const inpVal = ev.target.value

        setProductQuantity("1") // setting qunatity to default

        const isLevel1Available = document.querySelectorAll('.product-page-variation-viewer .level-1')

        if(isLevel1Available.length) {
            if (dataLevel !== 0) {
                setTimeout(() => {
                    const elemts = document.querySelectorAll('.product-page-variation-viewer .level-0 input:checked')
                    if (elemts?.length && elemts[0]?.parentElement) {
                        const dataId = elemts[0].parentElement.getAttribute("data-id")
    
                        setAllowedVariantsValues(availableCombinations[dataId]) // setting allowed options
                    }
                }, 20);
            }
        } else {
            setTimeout(() => {
                const elemts = document.querySelectorAll('.product-page-variation-viewer .level-0 input:checked')
                if (elemts?.length && elemts[0]?.parentElement) {
                    const dataId = elemts[0].parentElement.getAttribute("data-id")

                    setAllowedVariantsValues([dataId]) // setting allowed options
                }
            }, 20);
        }

        if (inpVal && item) {
            const dataId = generatingClass(item.option_variation_name) + "-" + item.id // generating dataId

            if (allowedVariantsValues?.length && allowedVariantsValues.find(item => item === dataId)) {
                const updatedData = {
                    [dataId.split('-')[0].toLowerCase()]: {
                        value: dataId
                    }
                }

                // setting current selected value
                setSelectedValue({ ...selectedValue, ...updatedData });

                setAllowedVariantsValues(allowedVariantsValues) // setting allowed options

            } else {
                if (availableCombinations && availableCombinations[dataId]) {
                    const optionsCombinations = Array.from(new Set(availableCombinations[dataId])) // removing duplicate values

                    const selectedItems = removeSimilars(optionsCombinations) // getting only the first option value from the allowed options

                    const data = {
                        [item.option_variation_name.toLowerCase()]: {
                            value: dataId,
                        }
                    }

                    selectedItems.forEach(sItem => {
                        data[sItem.split('-')[0].toLowerCase()] = {
                            value: sItem
                        }
                    })

                    // setting current selected value
                    setSelectedValue({ ...selectedValue, ...data });

                    setAllowedVariantsValues(availableCombinations[dataId]) // setting allowed options
                }
            }
        }
    }

    // when label click
    const handleLableClick = () => {
        setTimeout(() => {
            generateValues() // getting combinations values
        }, 200);
    }

    return (
        <React.Fragment>
            {/* title */}
            <span className={`title text-uppercase d-block st-fw-700 mb-1`}>{data.variation_name}</span>

            {/* listing */}
            <div className="rectangles-list">
                {/* rectangle */}
                {data?.options?.length &&
                    data.options.map(item => {
                        const dataId = generatingClass(item.option_variation_name) + "-" + item.id
                        const currentStage = allowedVariantsValues.find(item => item === dataId) ? "matched" : "unmatched"
                        // const shouldDisplayIcon = ((allowedVariantsValues?.length) && (currentStage === "unmatched") && (selectedValue[item.option_variation_name.toLowerCase()]?.value !== dataId))

                        return (
                            <label
                                key={item.id}
                                data-id={dataId}
                                className={`st-form-rectangle variant-option position-relative ${dataId} ${allowedVariantsValues?.length ? currentStage : "untouched"}`}
                                data-checked={(selectedValue[item.option_variation_name.toLowerCase()]?.value === dataId) ? "checked" : ""}
                                data-level={dataLevel}
                                onClick={handleLableClick} >
                                {/* input */}
                                <input
                                    type="radio"
                                    className="d-none"
                                    name={item.option_variation_name}
                                    value={item.value}
                                    checked={selectedValue[item.option_variation_name.toLowerCase()]?.value === dataId}
                                    onChange={ev => handleValueChange(ev, item, dataLevel)}
                                />

                                {/* text */}
                                <span className="rect">{item.value}</span>

                                {/* icon */}
                                {/* {
                                    shouldDisplayIcon ? (
                                        <span className="icon position-absolute st-st-line-height-0">
                                            <IoClose />
                                        </span>
                                    ) : null
                                } */}
                            </label>
                        )
                    })}
            </div>
        </React.Fragment >
    )
}
